import { Link } from "react-router-dom";

export default function Logo({ variant = "dark", className = "" }) {
  const color = variant === "light" ? "#FBFBF9" : "#14241F";
  return (
    <Link to="/" data-testid="brand-logo-link" className={`flex items-center gap-2.5 group ${className}`}>
      <img
        src="/ambuly-logo.png"
        alt="Ambuly"
        width={40}
        height={40}
        className="h-10 w-10 rounded-[10px] object-cover shadow-sm"
        loading="eager"
      />
      <span className="font-[Outfit] font-bold text-xl tracking-tight" style={{ color }}>
        Ambuly
      </span>
    </Link>
  );
}
